import { loanDetailsData } from "configs/loanDetails.config";
import { Dropdown, FilePicker, Input } from "stories";
import { ConditionalFormRenderer } from "../../../../../../../../stories/components/FormRenderer/ConditionalFormRenderer";
import { getPartnerModel } from "../../partners/Partners";
import { getPrincipalModel } from "../../partners/principals/Principals";
import {
  getCurrentProjectModal,
  getProjectModal,
} from "../../partners/projects/Projects";
import { corporationFields } from "./formStructures/corporationFields";
import { generalPartnershipFields } from "./formStructures/generalPartnershipFields";
import { jointVentureFields } from "./formStructures/jointVentureFields";
import { limitedLiabilityPartnershipFields } from "./formStructures/limitedLiabilityPartnershipFields";
import { limitedPartnershipFields } from "./formStructures/limitedPartnershipFields";
import { solePartnershipFields } from "./formStructures/solePartnershipFields";

export const getFormDefaultValue = () => ({
  corporate_structure: "",
  name_of_partnership: "",
  total_number_of_lp_units: null,
  address: "",
  biography: "",
  corporate_net_asset_value: "",
  corporation_name: "",
  fullname: "",
  hq_address: "",
  identification: "",
  industry: "",
  personal_net_worth: "",
  website: "",
  annual_returns_registrar_document_filename: null,
  incorporation_partnership_document_filename: null,
  minute_book_document_filename: null,
  organization_chart_filename: null,
  corporate_share_register_filename: null,
  incorporation_document_filename: null,
  financial_statement_filename: "",
  net_worth_document_filename: null,
  current_projects: [getCurrentProjectModal()],
  completed_projects: [getProjectModal()],
  partners: [getPartnerModel()],
  principals: [getPrincipalModel()],
});

const preFormFields = [
  [
    {
      name: "name",
      component: Input,
      props: {
        label: "Borrower Name",
      },
    },
    {},
  ],
  [
    {
      name: "organization_chart_filename",
      component: FilePicker,
      props: {
        label: "Organization Chart",
        type: "file",
      },
    },
    {},
  ],
];
const postFormFields = [
  [
    {
      renderAsFormItem: false,
      component: () => {
        return (
          <div className="section-title fw-bold">Supporting Documentation</div>
        );
      },
    },
  ],
  [
    {
      name: "incorporation_partnership_document_filename",
      component: FilePicker,
      props: {
        label: "Incorporation/Partnership Documentation",
        type: "file",
      },
    },
    {},
  ],
  [
    {
      name: "annual_returns_registrar_document_filename",
      component: FilePicker,
      props: {
        label: "Annual Returns/Registrar Documention",
        type: "file",
      },
    },
    {},
  ],
  [
    {
      name: "minute_book_document_filename",
      component: FilePicker,
      props: {
        label: "Minute Book Documentation",
        type: "file",
      },
    },
    {},
  ],
];
export const formStructure = {
  empty: [
    ...preFormFields,
    [
      {
        name: "corporate_structure",
        component: Dropdown,
        props: {
          label: "Corporate Structure",
          list: loanDetailsData.corporationTypeList,
        },
      },
      {},
    ],
  ],
  corporation: [...preFormFields, ...corporationFields, ...postFormFields],
  "limited partnership": [
    ...preFormFields,
    ...limitedPartnershipFields,
    ...postFormFields,
  ],
  "limited liability partnership": [
    ...preFormFields,
    ...limitedLiabilityPartnershipFields,
    ...postFormFields,
  ],
  "general partnership": [
    ...preFormFields,
    ...generalPartnershipFields,
    ...postFormFields,
  ],
  "joint venture": [...preFormFields, ...jointVentureFields, ...postFormFields],
  "sole proprietorship": [
    ...preFormFields,
    ...solePartnershipFields,
    ...postFormFields,
  ],
};

export const borrowerFormFields = [
  [
    {
      renderAsFormItem: false,
      component: ConditionalFormRenderer,
      props: {
        conditionFieldName: "corporate_structure",
        conditionalFields: formStructure,
        fallBackFields: formStructure.empty,
        cacheable: true,
        getDefaultValues: getFormDefaultValue,
      },
    },
  ],
];
